import { Link } from "react-router-dom";
import { ArrowRight, TrendingUp, TrendingDown, Minus } from "lucide-react";
import { TonePill } from "../ScoreGauge";

const CAUSE = { crime: "Emergency Preparedness", health: "Health & Wellness", politics: "Community Events", war: "Community Infrastructure",
  community: "Community Events", fundraising: "Food Security", recovery: "Health & Wellness", science: "Youth Mentorship", animals: "Animal Welfare", environment: "Environment" };

const weekChange = (series, dates) => {
  const pts = (series || []).map((v, i) => [v, i]).filter(([v]) => v != null);
  if (pts.length < 2) return null;
  const [lv, li] = pts[pts.length - 1];
  const base = pts.find(([, i]) => i >= li - 7 && i <= li - 2);
  if (!base) return null;
  const since = new Date(dates[base[1]] + "T12:00:00").toLocaleDateString("en-CA", { month: "short", day: "numeric" });
  return { d: Math.round(lv - base[0]), since };
};

const topDriver = (p, meta) => Object.entries(p.categories || {}).filter(([, n]) => n > 0).sort((a, b) => b[1] - a[1]).map(([k]) => ({ k, ...meta[k] }))[0];

const Change = ({ c }) => {
  if (!c) return <span className="text-xs text-slate-500">Not enough history yet</span>;
  const { d, since } = c;
  const Icon = d > 0 ? TrendingUp : d < 0 ? TrendingDown : Minus;
  return <span className={`inline-flex items-center gap-1 text-sm font-semibold ${d > 0 ? "text-emerald-700" : d < 0 ? "text-rose-600" : "text-slate-600"}`}><Icon size={15} />{d > 0 ? "+" : ""}{d} pts <span className="font-normal text-slate-500">since {since}</span></span>;
};

export const WeeklyDigest = ({ data, trend }) => {
  if (!data || !trend) return <div className="h-48 animate-pulse rounded-3xl bg-white" />;
  const rows = data.provinces.filter((p) => p.article_count > 0)
    .map((p) => ({ ...p, change: weekChange(trend.series[p.code], trend.dates), driver: topDriver(p, data.category_meta) }))
    .sort((a, b) => (b.change ? Math.abs(b.change.d) : -1) - (a.change ? Math.abs(a.change.d) : -1));
  return (
    <section className="mt-16" data-testid="weekly-digest">
      <p className="text-xs font-semibold uppercase tracking-widest text-sky-800">Weekly Pulse Digest</p>
      <h2 className="mt-3 font-serif text-3xl tracking-tight text-slate-900">What changed this week — and how to help</h2>
      <p className="mt-2 text-sm text-slate-600">Change compares each region's latest news tone score with its score up to a week earlier (history builds as feeds are read daily). Biggest moves first.</p>
      <div className="mt-6 grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {rows.map((p) => {
          const cause = CAUSE[p.driver?.k] || "Community Events";
          return (
            <article key={p.code} className="flex flex-col rounded-3xl border border-slate-200 bg-white p-5" data-testid={`digest-card-${p.code}`}>
              <div className="flex items-center justify-between gap-2"><h3 className="font-semibold text-slate-900">{p.name}</h3><TonePill score={p.score} /></div>
              <div className="mt-3 flex items-baseline gap-3"><span className="text-3xl font-bold text-slate-900">{Math.round(p.score)}</span><Change c={p.change} /></div>
              <p className="mt-2 text-sm text-slate-700">{p.driver ? <>Most-covered theme: <span className="font-medium">{p.driver.label}</span></> : "Mixed coverage this week."} · {p.article_count} headlines</p>
              <Link to={`/volunteer?province=${p.code}&category=${encodeURIComponent(cause)}`} data-testid={`digest-help-${p.code}`}
                className="mt-auto inline-flex items-center gap-1.5 pt-4 text-sm font-semibold text-emerald-700 hover:underline">
                Help in {p.name}: {cause} <ArrowRight size={14} className="shrink-0" />
              </Link>
            </article>
          );
        })}
      </div>
    </section>
  );
};
